import _slicedToArray from "/home/keneo/try_nodejs/react_sample_app/whoami-release/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import x from "react";
import { useRef as U } from "react";
import { useState as E, useRef as b, useCallback as q } from "react";
import { useEffect as M, useLayoutEffect as L } from "react";
var G = typeof window == "undefined" ? M : L,
  I = function I(_ref) {
    var o = _ref.isPlaying,
      e = _ref.duration,
      _ref$startAt = _ref.startAt,
      n = _ref$startAt === void 0 ? 0 : _ref$startAt,
      _ref$updateInterval = _ref.updateInterval,
      t = _ref$updateInterval === void 0 ? 0 : _ref$updateInterval,
      s = _ref.onComplete,
      r = _ref.onUpdate;
    var _E = E(n),
      _E2 = _slicedToArray(_E, 2),
      i = _E2[0],
      c = _E2[1],
      m = b(0),
      p = b(n),
      f = b(n * -1e3),
      u = b(null),
      a = b(null),
      h = b(null),
      w = function w(g) {
        var l = g / 1e3;
        if (a.current === null) {
          a.current = l, u.current = requestAnimationFrame(w);
          return;
        }
        var d = l - a.current,
          C = m.current + d;
        a.current = l, m.current = C;
        var k = p.current + (t === 0 ? C : (C / t | 0) * t),
          R = p.current + C,
          v = typeof e == "number" && R >= e;
        c(v ? e : k), v || (u.current = requestAnimationFrame(w));
      },
      $ = function $() {
        u.current && cancelAnimationFrame(u.current), h.current && clearTimeout(h.current), a.current = null;
      },
      y = q(function (g) {
        $(), m.current = 0;
        var l = typeof g == "number" ? g : n;
        p.current = l, c(l), o && (u.current = requestAnimationFrame(w));
      }, [o, n]);
    return G(function () {
      if (r == null || r(i), e && i >= e) {
        f.current += e * 1e3;
        var _ref2 = (s == null ? void 0 : s(f.current / 1e3)) || {},
          _ref2$shouldRepeat = _ref2.shouldRepeat,
          g = _ref2$shouldRepeat === void 0 ? !1 : _ref2$shouldRepeat,
          _ref2$delay = _ref2.delay,
          l = _ref2$delay === void 0 ? 0 : _ref2$delay,
          d = _ref2.newStartAt;
        g && (h.current = setTimeout(function () {
          return y(d);
        }, l * 1e3));
      }
    }, [i, e]), G(function () {
      return o && (u.current = requestAnimationFrame(w)), $;
    }, [o, e, t]), {
      elapsedTime: i,
      reset: y
    };
  };
var A = function A(o, e, n) {
    var t = o / 2,
      s = e / 2,
      r = t - s,
      i = 2 * r,
      c = n === "clockwise" ? "1,0" : "0,1",
      m = 2 * Math.PI * r;
    return {
      path: "m ".concat(t, ",").concat(s, " a ").concat(r, ",").concat(r, " 0 ").concat(c, " 0,").concat(i, " a ").concat(r, ",").concat(r, " 0 ").concat(c, " 0,-").concat(i),
      pathLength: m
    };
  },
  T = function T(o, e) {
    return o === 0 || o === e ? 0 : typeof e == "number" ? o - e : 0;
  },
  B = function B(o) {
    return {
      position: "relative",
      width: o,
      height: o
    };
  },
  P = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  };
var F = function F(o, e, n, t, s) {
    if (t === 0) return e;
    var r = (s ? t - o : o) / t;
    return e + n * r;
  },
  W = function W(o) {
    var e, n;
    return (n = (e = o.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, s, r, i) {
      return "#".concat(s).concat(s).concat(r).concat(r).concat(i).concat(i);
    }).substring(1).match(/.{2}/g)) == null ? void 0 : e.map(function (t) {
      return parseInt(t, 16);
    })) != null ? n : [];
  },
  j = function j(o, e) {
    var u;
    var n = o.colors,
      t = o.colorsTime,
      _o$isSmoothColorTrans = o.isSmoothColorTransition,
      s = _o$isSmoothColorTrans === void 0 ? !0 : _o$isSmoothColorTrans;
    if (typeof n == "string") return n;
    var r = (u = t == null ? void 0 : t.findIndex(function (a, h) {
      return a >= e && e >= t[h + 1];
    })) != null ? u : -1;
    if (!t || r === -1) return n[0];
    if (!s) return n[r];
    var i = t[r] - e,
      c = t[r] - t[r + 1],
      m = W(n[r]),
      p = W(n[r + 1]),
      f = !!o.isGrowing;
    return "rgb(".concat(m.map(function (a, h) {
      return F(i, a, p[h] - a, c, f) | 0;
    }).join(","), ")");
  },
  S = function S(o) {
    var e = o.duration,
      n = o.initialRemainingTime,
      t = o.updateInterval,
      _o$size = o.size,
      s = _o$size === void 0 ? 180 : _o$size,
      _o$strokeWidth = o.strokeWidth,
      r = _o$strokeWidth === void 0 ? 12 : _o$strokeWidth,
      i = o.trailStrokeWidth,
      _o$isPlaying = o.isPlaying,
      c = _o$isPlaying === void 0 ? !1 : _o$isPlaying,
      _o$isGrowing = o.isGrowing,
      m = _o$isGrowing === void 0 ? !1 : _o$isGrowing,
      _o$rotation = o.rotation,
      p = _o$rotation === void 0 ? "clockwise" : _o$rotation,
      f = o.onComplete,
      u = o.onUpdate,
      a = U(),
      h = Math.max(r, i != null ? i : 0),
      _A = A(s, h, p),
      w = _A.path,
      $ = _A.pathLength,
      _I = I({
        isPlaying: c,
        duration: e,
        startAt: T(e, n),
        updateInterval: t,
        onUpdate: typeof u == "function" ? function (l) {
          var d = Math.ceil(e - l);
          d !== a.current && (a.current = d, u(d));
        } : void 0,
        onComplete: typeof f == "function" ? function (l) {
          var R;
          var _ref3 = (R = f(l)) != null ? R : {},
            d = _ref3.shouldRepeat,
            C = _ref3.delay,
            k = _ref3.newInitialRemainingTime;
          if (d) return {
            shouldRepeat: d,
            delay: C,
            newStartAt: T(e, k)
          };
        } : void 0
      }),
      y = _I.elapsedTime,
      g = e - y;
    return {
      elapsedTime: y,
      path: w,
      pathLength: $,
      remainingTime: Math.ceil(g),
      rotation: p,
      size: s,
      stroke: j(o, g),
      strokeDashoffset: F(y, 0, $, e, m),
      strokeWidth: r
    };
  };
var D = function D(o) {
  var e = o.children,
    n = o.strokeLinecap,
    t = o.trailColor,
    s = o.trailStrokeWidth,
    _S = S(o),
    r = _S.path,
    i = _S.pathLength,
    c = _S.stroke,
    m = _S.strokeDashoffset,
    p = _S.remainingTime,
    f = _S.elapsedTime,
    u = _S.size,
    a = _S.strokeWidth;
  return x.createElement("div", {
    style: B(u)
  }, x.createElement("svg", {
    viewBox: "0 0 ".concat(u, " ").concat(u),
    width: u,
    height: u,
    xmlns: "http://www.w3.org/2000/svg"
  }, x.createElement("path", {
    d: r,
    fill: "none",
    stroke: t != null ? t : "#d9d9d9",
    strokeWidth: s != null ? s : a
  }), x.createElement("path", {
    d: r,
    fill: "none",
    stroke: c,
    strokeLinecap: n != null ? n : "round",
    strokeWidth: a,
    strokeDasharray: i,
    strokeDashoffset: m
  })), typeof e == "function" && x.createElement("div", {
    style: P
  }, e({
    remainingTime: p,
    elapsedTime: f,
    color: c
  })));
};
D.displayName = "CountdownCircleTimer";
export { D as CountdownCircleTimer, S as useCountdown };